import { render } from "./SectionDownloadCard.vue?vue&type=template&id=1e7e2dd9&scoped=true"
import script from "./SectionDownloadCard.vue?vue&type=script&lang=js"
export * from "./SectionDownloadCard.vue?vue&type=script&lang=js"

import "./SectionDownloadCard.vue?vue&type=style&index=0&id=1e7e2dd9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e7e2dd9"]])

export default __exports__